import { IUser } from "@types";
import { BaseAPI } from "@utils";

class UsersApi extends BaseAPI<IUser> {}

export const usersApi = new UsersApi("/api/v1/users");
